module.exports = __webpack_public_path__ + "static/home_background_2-2bbac90aa8bf2d11520746e294495466.jpg";